import * as z from "zod/v4";
import { type Tool } from "ai";
import { flattenUiPartsToString } from "../../ai-sdk/utils.ts";
import { type UIMessagePart } from "../../ai-sdk/ui-message.ts";

export const COMPACTION_SUMMARY_LIMIT = 6000;

export const CompactInputSchema = z.object({
  hint: z
    .string()
    .max(500)
    .optional()
    .describe(
      "Specific details the agent wants preserved in the summary (max 500 chars)",
    ),
});

export type CompactInput = z.infer<typeof CompactInputSchema>;

export const CompactOutputSchema = z.object({
  cleared: z.boolean().describe("Whether the context was cleared"),
});

export type CompactOutput = z.infer<typeof CompactOutputSchema>;

export type CompactTool = Tool<CompactInput, CompactOutput>;

export type SimpleMessage = { role: string; content: string };

/** Convert raw DB messages (with JSON parts) to simplified role+content pairs, dropping empty messages. */
export const simplifyMessages = (
  messages: Array<{ role: string; parts: unknown }>,
): SimpleMessage[] =>
  messages
    .map((m) => ({
      role: m.role,
      content: flattenUiPartsToString(m.parts as UIMessagePart[]),
    }))
    .filter((m) => m.content.length > 0);

export const compactOutputToMessage = (output: CompactOutput): string => {
  return output.cleared
    ? `Context compacted. Summary saved to memory.`
    : `Compaction failed.`;
};
